module.exports = __webpack_public_path__ + "img/__icon_MANY_TYPES.985e692b.svg";